import { useRef, useEffect, useState } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { Card } from '@bancobarigui/barihaus';

import { useChecklistContext } from '../contexts/ChecklistContext';
import { WorkspaceHeader } from './components/WorkspaceHeader';
import { WorkspaceContent } from './components/WorkspaceContent';
import { FloatingControls } from './components/FloatingControls';
export function ChecklistWorkspaceSection() {
  const {
    groups,
    addGroup,
    addSection,
    addQuestion,
    editGroup,
    editSection,
    editQuestion,
    removeGroup,
    removeSection,
    removeQuestion,
    duplicateGroup,
    duplicateSection,
    duplicateQuestion,
    handleDragEnd,
    undo,
    canUndo,
    redo,
    canRedo,
  } = useChecklistContext();

  const cardRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(true);
  const [isDragOverGroups, _setIsDragOverGroups] = useState(false);
  const [draggedType, setDraggedType] = useState<string | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry) {
          setIsVisible(entry.isIntersecting);
        }
      },
      { threshold: 0.1 }
    );

    const currentRef = cardRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const handleControlDragStart = (type: string) => {
    setDraggedType(type);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <div ref={cardRef}>
        <Card>
          <WorkspaceHeader
            hasGroups={groups.length > 0}
            onAddGroup={addGroup}
          />

          <WorkspaceContent
            groups={groups}
            draggedType={draggedType}
            isDragOverGroups={isDragOverGroups}
            onAddGroup={addGroup}
            onEditGroup={editGroup}
            onRemoveGroup={removeGroup}
            onDuplicateGroup={duplicateGroup}
            onAddSection={addSection}
            onEditSection={editSection}
            onRemoveSection={removeSection}
            onDuplicateSection={duplicateSection}
            onAddQuestion={addQuestion}
            onEditQuestion={editQuestion}
            onRemoveQuestion={removeQuestion}
            onDuplicateQuestion={duplicateQuestion}
          />
        </Card>
      </div>

      {isVisible && (
        <FloatingControls
          onAddGroup={addGroup}
          hasGroups={groups.length > 0}
          onDragStart={handleControlDragStart}
          onUndo={undo}
          canUndo={canUndo}
          onRedo={redo}
          canRedo={canRedo}
        />
      )}
    </DragDropContext>
  );
}
